import * as React from 'react';
import { State } from '../JobsPage.types';
import { TRANSCORP_STATES } from '../Transcorp/constants';

const re = /(?:\[([a-zÀ-ÿ-\s]+)\])/gi;

export const csrfParamToken = () => {
  const csrfParam = document.head
    .querySelector("meta[name='csrf-param']")
    ?.getAttribute('content');
  const csrfToken = document.head
    .querySelector("meta[name='csrf-token']")
    ?.getAttribute('content');

  if (typeof csrfParam === 'string' && typeof csrfToken === 'string') {
    return { param: csrfParam, token: csrfToken };
  }
  return {};
};

export const makeLinks = (text: string) => {
  const { gon } = window;
  const translationLinks = [gon.fssUrl, gon.issUrl];
  const matches = Array.from(text.matchAll(re));
  const tmpArray = [];
  if (matches.length > 0) {
    let index = 0;
    matches.forEach((match: any, matchIterationIndex) => {
      tmpArray.push(text.substring(index, match.index));
      tmpArray.push(
        <a key={match.index} href={translationLinks[matchIterationIndex]}>
          {match[1]}
        </a>
      );
      index = match.index + match[0].length;
    });
    tmpArray.push(text.substring(index));
  } else {
    tmpArray.push(text);
  }
  return <React.Fragment>{tmpArray.map((item) => item)}</React.Fragment>;
};

export const isStateHandledByTranscorp = (state: State) =>
  window?.gon?.swanFssBlocking &&
  TRANSCORP_STATES.includes(state?.abbreviation);
